/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

// required attributes
const PspChannelCodeR = t.interface({
  channel_code: t.string,

  payment_types: t.readonlyArray(t.string, "array of string")
});

// optional attributes
const PspChannelCodeO = t.partial({});

export const PspChannelCode = t.intersection(
  [PspChannelCodeR, PspChannelCodeO],
  "PspChannelCode"
);

export type PspChannelCode = t.TypeOf<typeof PspChannelCode>;
